import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { m as c } from "./tss-DN0acMKN.mjs";
import { t as l, u as d } from "./transformSpacingProps-m0OnDuSS.mjs";
const u = c()(({ spacing: r }, t) => ({
  root: typeof t == "object" && t !== null ? l(t, r) : {}
}));
function g(r) {
  const { children: t, component: i = "div", id: a, ...s } = r, { classes: o } = u(d(s)), n = i;
  return /* @__PURE__ */ m.jsx(n, { className: o.root, id: a, children: t });
}
const f = c()(({ spacing: r }, t) => {
  const i = [
    "gap",
    "rowGap",
    "columnGap",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY"
  ], a = (s) => Object.keys(s).reduce(
    (o, n) => {
      const e = s[n];
      return i.includes(n) && typeof e == "number" ? o[n] = r(e) : typeof e == "object" && e !== null ? o[n] = a(e) : o[n] = e, o;
    },
    {}
  );
  return {
    root: typeof t == "object" && t !== null ? a(t) : {}
  };
});
function j(r) {
  const { children: t, component: i = "div", display: a = "grid", id: s, ...o } = r, { classes: n } = f(d({ display: a, ...o })), e = i, p = [o["data-fabric-component"], "GridLayout"].filter(Boolean).join(" ");
  return /* @__PURE__ */ m.jsx(e, { className: n.root, "data-fabric-component": p, id: s, children: t });
}
j.Item = g;
export {
  j as G,
  g as I
};
//# sourceMappingURL=grid-layout-CIAmnVV8.mjs.map
